import React from 'react';
import { CloseIcon } from './Icons';
import './PhotoProcessingModal.css';

interface PhotoProcessingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (mode: 'raster' | 'style-only') => void;
}

const PhotoProcessingModal: React.FC<PhotoProcessingModalProps> = ({
  isOpen,
  onClose,
  onSelect
}) => {
  if (!isOpen) return null;

  const handleSelect = (mode: 'raster' | 'style-only') => {
    onSelect(mode);
    onClose();
  };

  return (
    <div className="photo-processing-modal-overlay" onClick={onClose}>
      <div className="photo-processing-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">请选择您想要的照片处理方式</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseIcon width="24" height="24" />
          </button>
        </div>
        
        <div className="modal-content">
          <div className="processing-options">
            <button 
              className="processing-option"
              onClick={() => handleSelect('raster')}
            >
              <div className="option-image">
                <div className="raster-preview">
                  <div className="layer layer-1"></div>
                  <div className="layer layer-2"></div>
                  <div className="layer layer-3"></div>
                </div>
              </div>
              <h3 className="option-title">光栅合成</h3>
              <p className="option-description">
                将您的照片与风格化效果进行光栅合成，创造立体视觉效果
              </p>
            </button>

            <button 
              className="processing-option"
              onClick={() => handleSelect('style-only')}
            >
              <div className="option-image">
                <div className="style-preview">
                  <div className="style-effect"></div>
                </div>
              </div>
              <h3 className="option-title">仅风格化</h3>
              <p className="option-description">
                对您的照片进行AI风格化处理，保留原始的平面效果
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoProcessingModal;
